var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.value ? _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.value.value,
      "breadCrumbs": _vm.breadCrumbs,
      "actions": _vm.actions,
      "chips": _vm.chips
    }
  }), _c('v-form', {
    ref: "form",
    model: {
      value: _vm.isFormValid,
      callback: function callback($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('v-row', {
    staticClass: "mb-4"
  }, [!_vm.isEdit ? _c('v-col', {
    staticClass: "mt-n2 justify-center d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c('tag-chip', {
    attrs: {
      "value": _vm.value,
      "size": "large"
    }
  })], 1) : _c('v-col', {
    staticClass: "mt-n2 justify-center d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c('tag-chip', {
    attrs: {
      "value": _vm.valueCopy,
      "size": "large"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isEdit,
      expression: "isEdit"
    }],
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "warning",
      "outlined": "",
      "dense": "",
      "border": "left"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center mt-n1 mb-n1",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailSave.unsavedChanges")) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.isSaveChangesLoading,
      "elevation": 0
    },
    on: {
      "click": _vm.abortChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "loading": _vm.isSaveChangesLoading,
      "disabled": !_vm.isFormValid,
      "readonly": !_vm.isEdit,
      "elevation": 0,
      "color": "success"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")])], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    ref: "titleField",
    attrs: {
      "label": _vm.$t('objects.tag.value'),
      "hint": _vm.$t('objects.tag.valueHint'),
      "persistent-hint": "",
      "readonly": !_vm.isEdit,
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE).concat(_vm.valueExistsRule),
      "maxlength": _vm.valueCopymaxLength,
      "counter": "",
      "outlined": ""
    },
    on: {
      "input": _vm.checkValueExists
    },
    model: {
      value: _vm.valueCopy.value,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "value", $$v);
      },
      expression: "valueCopy.value"
    }
  }), _vm.duplicate && _vm.isEdit ? _c('v-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.tag.valueExistsWarning")) + " "), _c('v-spacer'), _vm.duplicate ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.view = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.view")) + " ")]) : _vm._e()], 1)]) : _vm._e(), _vm.duplicate && _vm.view ? _c('tag-side-card', {
    on: {
      "close": function close($event) {
        _vm.view = false;
      }
    },
    model: {
      value: _vm.duplicate,
      callback: function callback($$v) {
        _vm.duplicate = $$v;
      },
      expression: "duplicate"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$t('objects.tag.description'),
      "hint": _vm.$t('objects.tag.descriptionHint'),
      "readonly": !_vm.isEdit,
      "persistent-hint": "",
      "outlined": "",
      "rows": 3,
      "auto-grow": ""
    },
    model: {
      value: _vm.valueCopy.description,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "description", $$v);
      },
      expression: "valueCopy.description"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.valueCopy.availableResources,
      "label": _vm.$t('objects.tag.resources'),
      "hint": _vm.$t('objects.tag.resourcesHint'),
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "persistent-hint": "",
      "readonly": !_vm.isEdit,
      "outlined": "",
      "multiple": "",
      "clearable": _vm.isEdit,
      "filter": _vm.getAutocompleteFilter(function (e) {
        return [_vm.$t("BackendResourceEnum.".concat(e))];
      })
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$t("BackendResourceEnum.".concat(item))) + " ")];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("BackendResourceEnum.".concat(item))) + " ")];
      }
    }], null, false, 1406323900),
    model: {
      value: _vm.valueCopy.resources,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "resources", $$v);
      },
      expression: "valueCopy.resources"
    }
  }), _vm.isEdit ? _c('div', {
    staticClass: "d-flex mt-n4"
  }, [_c('v-spacer'), _vm.valueCopy.resources.length !== _vm.valueCopy.availableResources.length ? _c('v-btn', {
    attrs: {
      "elevation": 0,
      "x-small": ""
    },
    on: {
      "click": _vm.setResources
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("tag.selectAllResources")) + " ")]) : _vm._e()], 1) : _vm._e()], 1), _vm.isEdit ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-subheader', [_vm._v(" " + _vm._s(_vm.$t("objects.tag.color")) + " ")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-sheet', {
    staticClass: "mr-1 ml-1",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "width": "45px",
      "height": "45px",
      "rounded": "",
      "color": _vm.valueCopy.color
    }
  }), _c('v-radio-group', {
    staticClass: "mt-n1 ml-2",
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.valueCopy.color,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "color", $$v);
      },
      expression: "valueCopy.color"
    }
  }, _vm._l(_vm.valueCopy.colors, function (color) {
    return _c('v-sheet', {
      key: color,
      staticClass: "mr-1 ml-1",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "center"
      },
      attrs: {
        "width": "45px",
        "height": "45px",
        "rounded": "",
        "color": color
      }
    }, [_c('v-radio', {
      staticClass: "mr-n2",
      attrs: {
        "color": "white",
        "value": color
      }
    })], 1);
  }), 1), _c('v-spacer')], 1)], 1) : _vm._e(), _vm.isEdit ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-subheader', [_vm._v(" " + _vm._s(_vm.$t("objects.tag.icon")) + " ")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-sheet', {
    staticClass: "mr-1 ml-1",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "width": "45px",
      "height": "45px",
      "rounded": "",
      "color": "grey lighten-3"
    }
  }, [_c('v-radio', {
    staticClass: "ml-4 mr-2",
    attrs: {
      "value": _vm.valueCopy.icon,
      "on-icon": _vm.valueCopy.icon,
      "off-icon": _vm.valueCopy.icon
    }
  })], 1), _c('v-radio-group', {
    staticClass: "mt-n2 ml-2",
    model: {
      value: _vm.valueCopy.icon,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "icon", $$v);
      },
      expression: "valueCopy.icon"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l(_vm.icons, function (icon) {
    return _c('v-sheet', {
      key: 'select-' + icon,
      staticClass: "ma-1",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "center"
      },
      attrs: {
        "width": "45px",
        "height": "45px",
        "rounded": "",
        "color": "grey lighten-3"
      }
    }, [_c('v-radio', {
      staticClass: "mr-n2",
      attrs: {
        "value": icon,
        "on-icon": icon,
        "off-icon": icon
      }
    })], 1);
  }), 1)]), _c('v-spacer')], 1)], 1) : _vm._e(), _vm.isEdit ? _c('v-col', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.isSaveChangesLoading,
      "elevation": 0
    },
    on: {
      "click": _vm.abortChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "loading": _vm.isSaveChangesLoading,
      "disabled": !_vm.isFormValid,
      "elevation": 0,
      "color": "success"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")])], 1) : _vm._e()], 1)], 1), _vm.isDeleteDialogActive && _vm.value ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "loading": _vm.isDeleteLoading,
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }, [_c('tag-chip', {
    attrs: {
      "item": _vm.value
    }
  })], 1) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }